/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { action, computed, set, setProperties } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import type { User } from 'frontend-utils/models';
import type MarketSettingsHotelsEditRoute from 'lumen/routes/market/settings/hotels/edit';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSettingsHotelsEditController extends Controller {
  declare model: ModelFrom<MarketSettingsHotelsEditRoute>;

  queryParams = ['userId', 'hotel', 'sortBy', 'sortOrder'];

  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];
  @service declare router: Services['router'];
  @service declare store: Services['store'];

  hotelText = '';
  searchTerm = '';
  userId: string | null = null;

  // Listen on model loading state because for the initial run the user might not be in the datastore yet
  @computed('userId', 'model.isLoading')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get editText() {
    const user = this.store.peekRecord<User>('user', this.userId!);
    let output = this.intl.t('settings.hotel_access.hotel_access').toString();

    if (user) {
      output += `: ${user.email}`;
    }

    return output;
  }

  @action changeHotelSearch(searchText: string): void {
    set(this, 'pageNb', 1);
    set(this, 'searchTerm', searchText);
  }

  @action redirectOnClose(): void {
    // Reset the filter value when popup is closed
    set(this, 'hotelText', '');

    set(this.model, 'userhotelrelationships', []);
    this.store.unloadAll('userhotelrelationship');

    let routeName = 'destination.settings.hotels';

    if (this.hotelAndMarketService.hotel) {
      routeName = 'hotel.settings.hotels';
    } else if (this.hotelAndMarketService.market) {
      routeName = 'market.settings.hotels';
    }

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.router.legacyTransitionTo(routeName, {
      queryParams: { refresh: true },
    });
  }

  @action refreshData(): void {
    this.send('doRefresh');
  }

  @action sortResults(column: { ascending: boolean; columnKey: string }): void {
    setProperties(this, {
      sortOrder: column.ascending ? 'asc' : 'desc',
      sortBy: column.columnKey,
    });
  }
}
